import graphql__7551288f80c5a672cf50 from "./__generated__/AnswerText_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import { useReadOnlyFieldProps } from "./useReadOnlyFieldProps";
import TextareaField from "../Form/Field/TextareaField";

const AnswerText = props => {
  const { content, formField } = useFragment(AnswerText_answer, props.answer);
  const { fieldName, label, required, hint, hintPosition, autoComplete } = formField;
  const { hide, disabled } = useReadOnlyFieldProps(formField);
  const { parent } = props;

  return (
    <TextareaField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      disabled={disabled}
      defaultValue={content}
      parent={parent}
      autoComplete={autoComplete}
    />
  );
};

const AnswerText_answer = graphql__7551288f80c5a672cf50;

export default AnswerText;
